import { RootState } from '@src/store'

export const selectAuthLoading = ({ auth }: RootState) => auth.isLoading

export const selectAuthUser = ({ auth }: RootState) => auth.currentUser || null

export const selectAuthPermissions = ({ auth }: RootState) => auth.currentUser?.permissions || []